import { createServerFn } from "@tanstack/react-start";
import { isRequestError } from "api-def";
import { getPermalink } from "src/CalmLensApi";
import { hasIdTokenCookie } from "src/lib/Bypass";

/**
 * Where a permalink opens for the visitor: the item's page in the portal, nothing when they're
 * signed out (they sign in at the link and it runs again), or not found when the item doesn't
 * exist or isn't theirs to open (the backend answers both alike).
 */
export const resolvePermalink = createServerFn({ method: "GET" })
  .validator((input: { type: string; id: string }) => input)
  .handler(
    async ({
      data,
    }): Promise<{ state: "signed-out" } | { state: "not-found" } | { path: string }> => {
      if (!hasIdTokenCookie()) return { state: "signed-out" };
      try {
        const response = await getPermalink.submit({ params: data });
        return { path: response.data.path };
      } catch (error) {
        if (isRequestError(error) && error.response?.status === 401) return { state: "signed-out" };
        if (isRequestError(error) && error.response?.status === 404) return { state: "not-found" };
        throw error;
      }
    },
  );
